/**
 * Doit rester strictement aligné sur ci.dematralEpress.enums.ModePaiement (backend).
 * - clé enum (= `value` envoyé à l'API) : NOM_ENUM_BACKEND
 * - valeur (= `label` affiché à l'utilisateur) : libellé FR
 */
export enum ModePaiement {
    ESPECE = 'Espèces',
    MOBILE_MONEY_MTN = 'Mobile Money MTN',
    MOBILE_MONEY_MOOV = 'Mobile Money Moov',
    MOBILE_MONEY_ORANGE = 'Mobile Money Orange',
    MOBILE_MONEY_WAVE = 'Mobile Money Wave',
    CHEQUE = 'Chèque',
    VIREMENT = 'Virement bancaire',
    TRAITE = 'Traite',
}
